"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linksToHcDomainCriterion = void 0;
const url_1 = require("../url/url");
const hcDomains = [
    'healthcare.com',
    'pivothealth.com',
    'cobrahealthcare.com',
    'healthcareinsider.com',
    'healthcaresmb.com',
    'medicareguide.com',
    'pivotmedicare.com',
    'healthsherpa.com',
];
/**
 * Evaluates if the link target is outside the current domain and if the target
 * is from Healthcare, Inc.
 *
 * v.0.12.0;
 * @public
 *
 * @param linkElement - Element which was clicked by the user.
 * @returns true if the link target is outside the current domain and if the
 * link target is a domain from the following list:
 * - healthcare.com
 * - pivothealth.com
 * - cobrahealthcare.com
 * - healthcareinsider.com
 * - healthcaresmb.com
 * - medicareguide.com
 * - pivotmedicare.com
 * - healthsherpa.com
 * Otherwise, it returns false.
 *
 * @example
 * ```ts
 * import {
 *   linksToHcDomainCriterion,
 * } from '@hc-frontend/third-party-snowplow';
 *
 * const defaultCriterion = linksToHcDomainCriterion(element);
 * ```
 */
function linksToHcDomainCriterion(linkElement) {
    const targetDomain = (0, url_1.getRootDomain)(linkElement.href);
    return (0, url_1.getRootDomain)() !== targetDomain && hcDomains.includes(targetDomain);
}
exports.linksToHcDomainCriterion = linksToHcDomainCriterion;
//# sourceMappingURL=cross-domain-linker-criterion.js.map